/* InnerIframe.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./InnerIframe.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { Suspense, useContext, useEffect, useMemo, useState, useRef, forwardRef, Fragment } from 'react';
import uuid from 'uuid/v4';
import { Box } from '@atlaskit/primitives/compiled';
import { useMergeRefs } from 'use-callback-ref';
import { fg } from '@atlaskit/platform-feature-flags';
import { EnvironmentContext } from '../../context';
import { useInvokeExtension, useSubscribeClientEventsBridge } from '../../web-client';
import { ThreeLOPrompt as _ThreeLOPrompt } from '../../components';
import { useBridge, useProductFetchClient, useNavigation, createBridgeApi, isBinaryContentType } from '../bridge';
import { useTracingContext } from '../../error-reporting';
import { getBrowserLocale, getBrowserTimezone, getResolverContext, getViewContext } from './utils';
import { isAppConsentedLocally, setAppConsentLocal } from './localAppConsent';
import { getLoadingComponent } from './utils/getLoadingComponent';
import { SANDBOX_DEPRECATION_ERROR } from '../../renderer/ForgeDeprecationMessage';
var styles = {
  threeLOInfo: "_1bsb1osq _4t3i1osq",
  box: "_kqswh2mm"
};

// TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
var modalIframeStyles = null;
var iframeStyles = null;
var hiddenIframeStyles = null;
var nonResizeableIframeStyles = null;
var defaultComponents = {
  ThreeLOPrompt: function ThreeLOPrompt(props) {
    return /*#__PURE__*/React.createElement(_ThreeLOPrompt, props);
  }
};

/**
 * Hook for determining default IFrame React ref, using parent ref when provided
 *
 * @param parentIframeRef parent IFrame React ref
 * @returns default IFrame React ref
 */
function useDefaultIframeRef(parentIframeRef) {
  var localIframeRef = useRef(null);
  var mergedRef = useMergeRefs([parentIframeRef, localIframeRef]);
  return mergedRef;
}
export var InnerIframe = /*#__PURE__*/forwardRef(function (_ref, parentIframeRef) {
  var accountId = _ref.accountId,
    extension = _ref.extension,
    contextIds = _ref.contextIds,
    apolloClient = _ref.apolloClient,
    components = _ref.components,
    coreData = _ref.coreData,
    extensionData = _ref.extensionData,
    extensionViewData = _ref.extensionViewData,
    loadingComponent = _ref.loadingComponent,
    onLoad = _ref.onLoad,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    src = _ref.src,
    bridge = _ref.bridge,
    customBridgeMethods = _ref.customBridgeMethods,
    isResizable = _ref.isResizable,
    getContextToken = _ref.getContextToken,
    timezone = _ref.timezone,
    locale = _ref.locale,
    setIsThreeLOPromptVisible = _ref.setIsThreeLOPromptVisible,
    setShouldShowRenderer = _ref.setShouldShowRenderer,
    extensionPayload = _ref.extensionPayload,
    isHidden = _ref.isHidden,
    theme = _ref.theme,
    surfaceColor = _ref.surfaceColor,
    appId = _ref.appId,
    isInModal = _ref.isInModal,
    setIsLoading = _ref.setIsLoading,
    onError = _ref.onError;
  var _ref2 = components ? components(defaultComponents) : defaultComponents,
    ThreeLOPrompt = _ref2.ThreeLOPrompt;
  var appIsAuthenticated = isAppConsentedLocally(appId, accountId);
  var consentUrl = extension.consentUrl,
    currentUserConsent = extension.currentUserConsent,
    requiresUserConsent = extension.requiresUserConsent,
    frameId = extension.properties.frameId;
  var _useState = useState(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated),
    _useState2 = _slicedToArray(_useState, 2),
    userConsentRequired = _useState2[0],
    setUserConsentRequired = _useState2[1];
  var productContext = useMemo(function () {
    var resolverContext = getResolverContext(coreData, extensionData);
    var viewContext = getViewContext({
      resolverContext: resolverContext,
      accountId: accountId,
      extension: extension,
      timezone: timezone !== null && timezone !== void 0 ? timezone : getBrowserTimezone(),
      locale: locale !== null && locale !== void 0 ? locale : getBrowserLocale(),
      extensionPayload: extensionPayload,
      extensionViewData: extensionViewData,
      theme: theme,
      surfaceColor: surfaceColor
    });
    return {
      resolverContext: resolverContext,
      viewContext: viewContext
    };
  }, [coreData, extensionData, extensionViewData, accountId, extension, timezone, locale, extensionPayload, theme, surfaceColor]);
  var tracing = useTracingContext();
  var contextTokenRef = useRef(undefined);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    threeLOInfo = _useState4[0],
    setThreeLOInfo = _useState4[1];
  var invokeRetriesRef = useRef([]);
  var iframeRef = useDefaultIframeRef(parentIframeRef);
  useEffect(function () {
    var clearThreeLOInfo = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", setThreeLOInfo(null));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function clearThreeLOInfo() {
        return _ref3.apply(this, arguments);
      };
    }();
    if (userConsentRequired) {
      tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - start');
      setThreeLOInfo({
        authUrl: consentUrl,
        onSuccess: function () {
          var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - end', 'success');
                  setUserConsentRequired(false);
                  setIsThreeLOPromptVisible(false);
                  setAppConsentLocal(appId, accountId);
                  return _context2.abrupt("return", clearThreeLOInfo());
                case 5:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function onSuccess() {
            return _onSuccess.apply(this, arguments);
          }
          return onSuccess;
        }(),
        onReject: function onReject() {
          tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - end', 'rejected');
          return clearThreeLOInfo();
        }
      });
      setIsThreeLOPromptVisible(true);
      setShouldShowRenderer === null || setShouldShowRenderer === void 0 || setShouldShowRenderer(false);
      if (onLoad) {
        onLoad();
      }
    }
  }, [onLoad, setIsThreeLOPromptVisible, setShouldShowRenderer, tracing, appId, accountId, consentUrl, userConsentRequired]);
  var navigation = useNavigation({
    extension: extension,
    push: bridge === null || bridge === void 0 ? void 0 : bridge.spaPush
  });
  var invoker = useInvokeExtension(contextIds, extension.id, {
    client: apolloClient
  });

  // this hook has no side effect (i.e. does not actively trigger any network calls or actively making any subscription.
  // It is because everything inside this hook is lazily initialized.
  // Importantly:
  // - It only has impact when the subscribeClientEvent is called by the client (i.e. @forge/bridge)
  // - The backend service is feature flagged and is not live in production, hence calling this hook in production or without
  //   enabled falg will have no impact.
  var _useSubscribeClientEv = useSubscribeClientEventsBridge(appId, extension.installationId),
    subscribeClientEvent = _useSubscribeClientEv.subscribeClientEvent;
  var environment = useContext(EnvironmentContext);
  var cloudId = coreData.cloudId,
    workspaceId = coreData.workspaceId;
  var productFetchClient = useProductFetchClient({
    appId: appId,
    environment: environment,
    contextIds: contextIds,
    cloudId: cloudId,
    workspaceId: workspaceId,
    extensionId: extension.id,
    options: {
      client: apolloClient
    },
    renderThreeLOPrompt: function renderThreeLOPrompt(retry) {
      return new Promise(function (resolve, reject) {
        var authUrl = (threeLOInfo === null || threeLOInfo === void 0 ? void 0 : threeLOInfo.authUrl) || consentUrl;
        if (authUrl) {
          invokeRetriesRef.current.push(retry);
          tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - start');
          setThreeLOInfo({
            authUrl: authUrl,
            onSuccess: function onSuccess() {
              tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - end', 'success');
              resolve();
              setThreeLOInfo(null);
              setIsThreeLOPromptVisible(false);
              setShouldShowRenderer === null || setShouldShowRenderer === void 0 || setShouldShowRenderer(true);
              return Promise.all(invokeRetriesRef.current.map(function (retry) {
                return retry();
              })).then(function () {
                invokeRetriesRef.current = [];
              });
            },
            onReject: function onReject() {
              tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - end', 'rejected');
              return reject();
            }
          });
          setIsThreeLOPromptVisible(true);
          setShouldShowRenderer === null || setShouldShowRenderer === void 0 || setShouldShowRenderer(false);
        }
      });
    }
  });
  var _useBridge = useBridge({
      theme: theme,
      surfaceColor: surfaceColor,
      origin: new URL(src).origin,
      api: _objectSpread(_objectSpread({}, createBridgeApi(bridge, {
        userConsentRequired: !!userConsentRequired
      })), {}, {
        onInvoke: function () {
          var _onInvoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
            var _contextTokenRef$curr, _resp$response;
            var newContextToken, _yield$invoker, data, resp, _resp$errors, _error$message, error, _error$extensions$fie;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  if (!getContextToken) {
                    _context3.next = 6;
                    break;
                  }
                  _context3.next = 3;
                  return getContextToken();
                case 3:
                  _context3.t0 = _context3.sent;
                  _context3.next = 7;
                  break;
                case 6:
                  _context3.t0 = (_contextTokenRef$curr = contextTokenRef.current) === null || _contextTokenRef$curr === void 0 ? void 0 : _contextTokenRef$curr.jwt;
                case 7:
                  newContextToken = _context3.t0;
                  tracing === null || tracing === void 0 || tracing.recordGqlCall('invokeExtension - start');
                  _context3.next = 11;
                  return invoker({
                    call: payload,
                    context: _objectSpread({}, productContext.resolverContext),
                    extensionPayload: extensionPayload,
                    contextToken: newContextToken
                  });
                case 11:
                  _yield$invoker = _context3.sent;
                  data = _yield$invoker.data;
                  resp = data === null || data === void 0 ? void 0 : data.invokeExtension;
                  if (resp !== null && resp !== void 0 && resp.success) {
                    _context3.next = 20;
                    break;
                  }
                  error = resp === null || resp === void 0 || (_resp$errors = resp.errors) === null || _resp$errors === void 0 ? void 0 : _resp$errors[0];
                  if (!((error === null || error === void 0 ? void 0 : error.extensions.errorType) === 'USER_CONSENT_REQUIRED')) {
                    _context3.next = 18;
                    break;
                  }
                  return _context3.abrupt("return", {
                    type: '3lo',
                    authUrl: error === null || error === void 0 || (_error$extensions$fie = error.extensions.fields) === null || _error$extensions$fie === void 0 ? void 0 : _error$extensions$fie.authInfoUrl
                  });
                case 18:
                  if ((error === null || error === void 0 ? void 0 : error.extensions.errorType) === SANDBOX_DEPRECATION_ERROR && onError && fg('platform_render_sandbox_runtime_error_panel')) {
                    onError(error === null || error === void 0 ? void 0 : error.extensions.errorType);
                  }
                  return _context3.abrupt("return", {
                    type: 'err',
                    message: (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : 'An error occurred while trying to invoke.'
                  });
                case 20:
                  tracing === null || tracing === void 0 || tracing.recordGqlCall('invokeExtension - end');
                  contextTokenRef.current = resp === null || resp === void 0 ? void 0 : resp.contextToken;
                  return _context3.abrupt("return", {
                    type: 'ok',
                    response: resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.body
                  });
                case 23:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function onInvoke(_x) {
            return _onInvoke.apply(this, arguments);
          }
          return onInvoke;
        }(),
        onNavigate: navigation.onNavigate,
        onThreeLO: function () {
          var _onThreeLO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(authUrl, retry) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", new Promise(function (resolve, reject) {
                    invokeRetriesRef.current.push(retry);
                    tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                      authUrl: authUrl,
                      onSuccess: function onSuccess() {
                        tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - end', 'success');
                        resolve();
                        setThreeLOInfo(null);
                        setIsThreeLOPromptVisible(false);
                        setShouldShowRenderer === null || setShouldShowRenderer === void 0 || setShouldShowRenderer(true);
                        return Promise.all(invokeRetriesRef.current.map(function (retry) {
                          return retry();
                        })).then(function () {
                          invokeRetriesRef.current = [];
                        });
                      },
                      onReject: function onReject() {
                        tracing === null || tracing === void 0 || tracing.recordConsentFlow('consent flow - end', 'rejected');
                        return reject();
                      }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer === null || setShouldShowRenderer === void 0 || setShouldShowRenderer(false);
                  }));
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function onThreeLO(_x2, _x3) {
            return _onThreeLO.apply(this, arguments);
          }
          return onThreeLO;
        }(),
        getContext: function () {
          var _getContext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", _objectSpread({}, productContext.viewContext));
                case 1:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          function getContext() {
            return _getContext.apply(this, arguments);
          }
          return getContext;
        }(),
        fetchProduct: function () {
          var _fetchProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref4) {
            var restPath, product, fetchRequestInit, isMultipartFormData, response, status, statusText, headers, isAttachment, body;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  restPath = _ref4.restPath, product = _ref4.product, fetchRequestInit = _ref4.fetchRequestInit, isMultipartFormData = _ref4.isMultipartFormData;
                  _context6.next = 3;
                  return productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                case 3:
                  response = _context6.sent;
                  status = response.status, statusText = response.statusText;
                  headers = Object.fromEntries(response.headers.entries());
                  isAttachment = isBinaryContentType(response.headers.get('content-type'));
                  if (!response.body) {
                    _context6.next = 13;
                    break;
                  }
                  _context6.next = 10;
                  return response.text();
                case 10:
                  _context6.t0 = _context6.sent;
                  _context6.next = 14;
                  break;
                case 13:
                  _context6.t0 = undefined;
                case 14:
                  body = _context6.t0;
                  return _context6.abrupt("return", {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                  });
                case 16:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function fetchProduct(_x4) {
            return _fetchProduct.apply(this, arguments);
          }
          return fetchProduct;
        }(),
        getFrameId: function getFrameId() {
          return frameId !== null && frameId !== void 0 ? frameId : null;
        },
        subscribeClientEvent: subscribeClientEvent
      }),
      customBridgeMethods: customBridgeMethods,
      onLoad: onLoad,
      isResizable: isResizable,
      height: height,
      environment: environment,
      extension: extension,
      iframeRef: iframeRef,
      client: apolloClient,
      contextIds: contextIds
    }),
    loading = _useBridge.loading,
    onLoadIframeFromProps = _useBridge.iframeProps.onLoad;
  useEffect(function () {
    setIsLoading === null || setIsLoading === void 0 || setIsLoading(loading);
  }, [loading, setIsLoading]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.box,
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      height: isResizable || threeLOInfo ? undefined : height,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      width: width
    }
  }, navigation.getModalJsx(), (loading || threeLOInfo) && (fg('fix-react-18-concurrent-upgrade-infinite-rendering') ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.threeLOInfo
  }, loading && !threeLOInfo && !isHidden && getLoadingComponent(loadingComponent), threeLOInfo && ThreeLOPrompt({
    authUrl: threeLOInfo.authUrl,
    onSuccess: threeLOInfo.onSuccess,
    metadata: {
      moduleType: extension.type
    }
  })) : /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.threeLOInfo
  }, loading && !threeLOInfo && !isHidden && getLoadingComponent(loadingComponent), threeLOInfo && ThreeLOPrompt({
    authUrl: threeLOInfo.authUrl,
    onSuccess: threeLOInfo.onSuccess,
    metadata: {
      moduleType: extension.type
    }
  })))), !userConsentRequired && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("iframe", {
    "data-testid": "hosted-resources-iframe",
    "data-forge-iframe": true,
    sandbox: "allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts",
    allow: "camera; clipboard-write; display-capture; fullscreen; microphone",
    src: src,
    ref: iframeRef,
    onLoad: onLoadIframeFromProps,
    title: "Iframe ".concat(frameId !== null && frameId !== void 0 ? frameId : uuid(), " from ").concat(appId),
    className: ax(["_19itglyw _1e0c1ule _1bsb1osq", (loading || threeLOInfo || isHidden) && "_1e0cglyw", isInModal && "_2rko1sit _4t3i1osq", !isResizable && "_4t3i1osq"])
  })));
});